// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"ff0c4a79","221":"f8ad47e2","239":"ca92b567","429":"80105cb1","453":"870b3741","455":"5549dea5","977":"8a16579d"}[chunkId] + ".chunk.js";
};